import { theme } from '@chakra-ui/react';

export default {
  ...theme.colors,
  black: '#000000',
  blackAlpha: {
    '100': 'rgba(0, 0, 0, 0.1)',
    '200': 'rgba(0, 0, 0, 0.2)',
    '300': 'rgba(0, 0, 0, 0.3)',
    '400': 'rgba(0, 0, 0, 0.4)',
    '50': 'rgba(0, 0, 0, 0.05)',
    '500': 'rgba(0, 0, 0, 0.5)',
    '600': 'rgba(0, 0, 0, 0.6)',
    '700': 'rgba(0, 0, 0, 0.7)',
    '800': 'rgba(0, 0, 0, 0.8)',
    '900': 'rgba(0, 0, 0, 0.9)',
  },
  blue: {
    '100': '#BAD9FC',
    '200': '#8EC0FB',
    '300': '#62A7F9',
    '400': '#368EF7',
    '50': '#E6F1FE',
    '500': '#0976F6',
    '600': '#075EC5',
    '700': '#064793',
    '800': '#042F62',
    '900': '#021831',
  },
  brand: theme.colors.blue,
  cyan: {
    '100': '#BAE6FC',
    '200': '#8ED6FB',
    '300': '#62C6F9',
    '400': '#36B6F7',
    '50': '#E6F6FE',
    '500': '#09A5F6',
    '600': '#0784C5',
    '700': '#066393',
    '800': '#044262',
    '900': '#022131',
  },
  gray: {
    '100': '#D9DADB',
    '200': '#C1C2C6',
    '25': '#F7F7F7',
    '300': '#A8ABAF',
    '400': '#909F99',
    '50': '#F1F1F1',
    '500': '#787C82',
    '600': '#60656C',
    '700': '#474E56',
    '800': '#2F3640',
    '900': '#171F2A',
  },
  green: {
    '100': '#C6F0CD',
    '200': '#A2E7AD',
    '300': '#7DDE8D',
    '400': '#59D46D',
    '50': '#EBFAED',
    '500': '#34CB4D',
    '600': '#2AA24E',
    '700': '#1F7A2E',
    '800': '#1FF11F',
    '900': '#0A290F',
  },
  orange: {
    '100': '#FFD6B8',
    '200': '#FFBB8A',
    '300': '#FFA05C',
    '400': '#FF862E',
    '50': '#FEEBCB',
    '500': '#FF6B00',
    '600': '#CC5600',
    '700': '#994000',
    '800': '#662B00',
    '900': '#331500',
  },
  pink: {
    '100': '#F4BAFC',
    '200': '#EC8EFB',
    '300': '#E562F9',
    '400': '#DE36F7',
    '50': '#FBE6FE',
    '500': '#D609F6',
    '600': '#AC07C5',
    '700': '#810693',
    '800': '#560462',
    '900': '#2B0231',
  },
  purple: {
    '100': '#CECCEB',
    '200': '#AFABDE',
    '300': '#8F8AD1',
    '400': '#7069C4',
    '50': '#EEEDF8',
    '500': '#5148B7',
    '600': '#413993',
    '700': '#302B6E',
    '800': '#201D49',
    '900': '#100E25',
  },
  red: {
    '100': '#FFB8B8',
    '200': '#FF8A8A',
    '300': '#FF5C5C',
    '400': '#FF2E3E',
    '50': '#FFE5E5',
    '500': '#FF0000',
    '600': '#CC0000',
    '700': '#990000',
    '800': '#660000',
    '900': '#330000',
  },
  teal: {
    '100': '#C6F0E9',
    '200': '#A2E7DB',
    '300': '#7DDECE',
    '400': '#59D4C0',
    '50': '#EBFAF7',
    '500': '#34CBB2',
    '600': '#2AA28E',
    '700': '#1F7A6B',
    '800': '#155147',
    '900': '#0A2924',
  },
  white: '#FFFFFF',
  yellow: {
    '100': '#FEFCBF',
    '200': '#FAF08F',
    '300': '#F8EA63',
    '400': '#F6E437',
    '50': '#FFFFF0',
    '500': '#F4DE0B',
    '600': '#C3B109',
    '700': '#938506',
    '800': '#625904',
    '900': '#312C02',
  },
};
